var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "container-m" },
    [
      _c(
        "v-container",
        {
          staticStyle: { "padding-top": "0px" },
          attrs: { id: "main-container", fluid: "", "fill-height": "" }
        },
        [
          _c(
            "v-layout",
            { attrs: { flex: "", "align-center": "", "justify-center": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm12: "", md12: "", lg12: "" } },
                [
                  _c("page-title", {
                    attrs: { title: "Neue Support Anfrage" }
                  }),
                  _vm._v(" "),
                  _vm.userInstallationDateVm.isShowHeaderText
                    ? _c(
                        "p",
                        {
                          staticClass: "title text--darken-1",
                          staticStyle: { "text-align": "center" }
                        },
                        [
                          _vm._v(
                            "\n          Wir freuen uns Sie Neukunde bei WERBAS//KSR begrüßen zun dürfen.\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userInstallationDateVm.isShowHeaderText
                    ? _c(
                        "p",
                        {
                          staticClass: "subtitle text--darken-1",
                          staticStyle: { "text-align": "center" }
                        },
                        [
                          _vm._v(
                            "\n          Tragen Sie unten bitte Ihre Frage an uns ein. Wir werden uns\n          bemühen, diese schnellstens zu beantworten.\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { id: "new-support-request-form" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            wrap: "",
                            "justify-center": "",
                            "align-right": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "form-column",
                              attrs: { xs12: "", md12: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "custom-label-color",
                                attrs: {
                                  rules: [
                                    _vm.rules.required,
                                    _vm.rules.maxLength
                                  ],
                                  label:
                                    "Geben Sie einen und aussagekräftigem Betreff an (max. 45 Zeichen): (Beispiel: Addresse kann nicht geloscht werden)"
                                },
                                model: {
                                  value: _vm.subject,
                                  callback: function($$v) {
                                    _vm.subject =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "subject"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md12: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "custom-label-color",
                                attrs: {
                                  label:
                                    "Bitte nennen Sie uns den Ansprechpartner in Ihrem Haus, der mit dieser Anfrage betraut ist",
                                  rules: [
                                    _vm.rules.required,
                                    _vm.rules.maxLength
                                  ]
                                },
                                model: {
                                  value: _vm.contactPerson,
                                  callback: function($$v) {
                                    _vm.contactPerson =
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                  },
                                  expression: "contactPerson"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md12: "" } },
                            [
                              _c("v-combobox", {
                                staticClass: "custom-field",
                                attrs: {
                                  label:
                                    "Bitte wählen Sie die Produkt-Linie, die von Ihrer Anfrage betroffen ist.",
                                  rules: [_vm.rules.required],
                                  items: _vm.productLines,
                                  disabled: _vm.oneProductLine
                                },
                                model: {
                                  value: _vm.products.productLineSelected,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.products,
                                      "productLineSelected",
                                      $$v
                                    )
                                  },
                                  expression: "products.productLineSelected"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md12: "" } },
                            [
                              _c("v-combobox", {
                                staticClass: "custom-field",
                                attrs: {
                                  label:
                                    "Bitte wählen Sie das Produkt, das von Ihrer Anfrage betroffen ist.",
                                  rules: [_vm.rules.required],
                                  items: _vm.filteredProductList,
                                  "search-input": _vm.products.search
                                },
                                on: {
                                  "update:searchInput": function($event) {
                                    return _vm.$set(
                                      _vm.products,
                                      "search",
                                      $event
                                    )
                                  },
                                  "update:search-input": function($event) {
                                    return _vm.$set(
                                      _vm.products,
                                      "search",
                                      $event
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.products.itemSelected,
                                  callback: function($$v) {
                                    _vm.$set(_vm.products, "itemSelected", $$v)
                                  },
                                  expression: "products.itemSelected"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            wrap: "",
                            "justify-center": "",
                            "align-right": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md12: "" } },
                            [
                              _c("v-textarea", {
                                staticClass: "custom-label-color",
                                attrs: {
                                  label:
                                    "Beschreiben Sie bitte moglichst detailiert Ihre Anfrage",
                                  rules: [
                                    _vm.rules.required,
                                    _vm.rules.maxLengthRequest
                                  ]
                                },
                                model: {
                                  value: _vm.description,
                                  callback: function($$v) {
                                    _vm.description = $$v
                                  },
                                  expression: "description"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: {
                            wrap: "",
                            flex: "",
                            "align-right": "",
                            "justify-end": ""
                          }
                        },
                        [
                          _vm.kindOfSupport.isShowPrioCall
                            ? _c(
                                "v-flex",
                                {
                                  staticClass: "right-button-container",
                                  attrs: { id: "right", xs12: "", md6: "" }
                                },
                                [
                                  _vm.userInstallationDateVm.isShowPrioCall
                                    ? _c("v-checkbox", {
                                        staticClass: "custom-label-color",
                                        attrs: {
                                          label:
                                            "Prio-call (bevorzugte Bearbeitung - dafür entstehen weitere Kosten)",
                                          color: "#0F1E32"
                                        },
                                        model: {
                                          value: _vm.prioCallOption,
                                          callback: function($$v) {
                                            _vm.prioCallOption = $$v
                                          },
                                          expression: "prioCallOption"
                                        }
                                      })
                                    : _c(
                                        "p",
                                        {
                                          staticStyle: { "margin-top": "16px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Da Fragen in der ersten Zeit oftmals, besonders wichtig sind,\n                behandeln wir alle Ihre Anfragen innerhalb der ersten 14 Tage\n                automatisch als Prio-Calls. Nutzen Sie die Option nach dieser\n                Zeit bitte nur noch dann sofern es sich wirklich um sehr\n                dringende Punkte handelt.\n              "
                                          )
                                        ]
                                      )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "right-button-container",
                              staticStyle: { "margin-top": "16px" },
                              attrs: { id: "right", xs12: "", md6: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { id: "form-button" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.goTo()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Zurück\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    id: "form-button",
                                    disabled: _vm.sendClickedAndFormWasValid
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.checkForm($event)
                                    }
                                  }
                                },
                                [_vm._v("Anfrage an WERBAS//KSR senden")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.errors.length !== 0
                    ? _c(
                        "v-container",
                        _vm._l(_vm.errors, function(error, index) {
                          return _c(
                            "p",
                            { key: index },
                            [
                              _c(
                                "v-alert",
                                {
                                  attrs: {
                                    color: "red darken-2",
                                    icon: "warning",
                                    dismissible: "",
                                    outline: ""
                                  },
                                  model: {
                                    value: error.visible,
                                    callback: function($$v) {
                                      _vm.$set(error, "visible", $$v)
                                    },
                                    expression: "error.visible"
                                  }
                                },
                                [_vm._v(_vm._s(error.message))]
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("finished-page-dialog", { ref: "finishedPageDialog" })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }